export default __webpack_public_path__ + "static/media/how-to-send-an-offer.1ffed204.png";